export default state => state.savedItems.showNotificationsOptIn === true;
